module.exports = __webpack_public_path__ + "static/img/twitter.0efe7b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/showcase/twitter.jpg
// module id = wW7q
// module chunks = 0